import { get } from '..';

const getTicketBrief = (ticketId: string) => get(`chatbot-api/tickets/${ticketId}/brief`);

export default getTicketBrief;
